var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":false,"showSearch":false,"showExportation":false}},[_vm._v("الحجوزات")]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":"admin/reservations","baseURL":_vm.VUE_APP_VETE_LINK}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }